import React from 'react'

function GithubStats() {
  return (
    <>

    <div className="text-dark">
      <img src="https://github-readme-stats.vercel.app/api?username=lasyanga&theme=dracula" alt="github-stats" width="100%" />
    </div>
    </>
  )
}

export default GithubStats